export default __webpack_public_path__ + "static/media/prep-time.74bfc2e2.svg";